<template>
  <div :class="['main main__container', cssClasses]">
    <oie-layout-grid css-classes="grid--two">
      <div class="sign-in">
        <h3 v-epi-edit="'ForgotPasswordHeader'" class="sign-in__header">
          {{ t('forgotPasswordHeader') }}
        </h3>

        <p class="sign-in__description">
          {{ t('forgotPasswordDescription') }}
        </p>

        <oie-forgot-password-box
          register-url="registerUrl">
        </oie-forgot-password-box>
      </div>
    </oie-layout-grid>
  </div>
</template>

<script>
export default {
  props: {
    referrer: {
      type: String,
      required: false,
      default: ''
    },
    checkOutUrl: {
      type: String,
      required: false,
      default: decodeURIComponent(window.location.search.replace(/\?returnurl=/ig, ''))
    }
  }
}
</script>

<style lang="scss">
.sign-in--register {
  @include media(small) {
    padding-left: calc(#{measure(double)} * 2);
  }

  @include media(medium) {
    padding-left: calc(#{measure(double)} * 4);
  }
}

.sign-in__header {
  @include h2-semi-bold;
  color: color(text-blue);
  margin: 0 measure(half) 0 0;
}

.sign-in__description {
  @include body;
  margin-bottom: measure(full);
}

.sign-in__button {
  width: 100%;

  @include media(small) {
    width: 15rem;
  }
}

.sign-in__as-guest {
  padding-top: measure(double);
}
</style>
